import styled from 'styled-components';

export const Container = styled.section`
  width: 100%;
  height: 100%;
  padding: 1.25rem;
`;

export const CanceladoContainer = styled.div`
  display: flex;
  height: 41px;
  width: 200px;
  background-color: #ffff00;
  margin-top: 1.8rem;
  border-radius: 5px;

  .cancel {
    width: 100%;
    color: #ff0000;
    font-size: 1.525rem;
    line-height: 2.4375rem;
    border-radius: 0.3125rem;
    background-color: yellow;
    text-align: center;
  }
`;
